export default __webpack_public_path__ + "static/media/loc.0ce19830.svg";